import { v4 as uuidv4 } from 'uuid';
export var CHANNEL_NAME = 'embedded-confluence-iframe';
export var createUniqueKey = function createUniqueKey() {
  return "".concat(CHANNEL_NAME, "-").concat(uuidv4());
};
export var PASSTHROUGH_PROPS_MODULE_NAME = 'passThroughProps';
export var PROPS_UPDATED = 'propsUpdated';
export var EXPERIENCE_FORWARDING_MODULE_NAME = 'experienceForwarding';